{
  "date_must_be_today_or_later": "Date must be today or later",
  "additional_compensation_amount_required": "Enter at least one amount",
  "duration_exceeds_max_hours": "Duration can't exceed {hours}h",
  "end_date_should_be_greater_start_date": "End date can't be before start date",
  "end_time_should_be_greater_start_time": "End time can't be before start time",
  "field_email_required": "Field should be a valid email",
  "field_number_required": "You need to enter a numeric value",
  "field_required": "Field is required",
  "field_url_invalid": "Enter a valid URL",
  "forms_validation_error": "Choose a form for each reviewer type to continue",
  "no_file_selected": "Select file to upload",
  "image_min_size": "Image must be at least {size}px by {size}px",
  "invalid_decimal_format": "Enter a number with no more than two decimal places",
  "only_one_file_allowed_generic": "Please upload only one file",
  "only_one_file_allowed": "Please upload only one file with one of the following extensions: {formats}",
  "page_not_found": "The page you are looking for is not available",
  "page_not_found_description": "We are sorry for the inconvenience, the page you are trying to access has been removed or never been existed",
  "password_required": "Password is required",
  "plan_inactive_description": "Your access is limited. Please contact %APP_NAME% support at {email} to restore your plan",
  "plan_inactive_title": "Your plan has expired",
  "crash_title": "Oops, something broke",
  "crash_description": "We've already received the error details. Head back to the home page and try again.",
  "reviewers_validation_error": "Select at least one type of reviewer to continue",
  "server_error": "Oops! Something went wrong on our end. Please try again later",
  "unsupported_file_format": "This file format is not supported. Please upload a file with one of the following extensions: {formats}",
  "value_cannot_be_negative": "Value cannot be negative",
  "~": "~",
  "field_max_length": "Use no more than {characters}"
}
